import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
import { cloneDeep } from 'lodash';

// const projectName = '/api/blade-platform';

const common = {
  state: {
    newSearchParams: '',
  },
  mutations: {
    SET_newSearchParams:(state, newSearchParams)=> {
      const st = state;
      st.newSearchParams = cloneDeep(newSearchParams);
    },
  },
  actions: {
      // 上传图片
    facUpload(actions, data) {
      return request({
        url: `/api/blade-workbench/eduSystemManageGuiseLogo/upload`,
        method: 'post',
        data,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
      // 上传图片
      fileUpload(actions, data) {
      return request({
        url: `/api/blade-platform/file/upload`,
        method: 'post',
        data,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
    /**
     * 查询服务列表
     * @param {*} param0 context
     */

  },
};

export default common;
